import React, { useEffect } from "react";

import { useModal } from "../../../../providers/ModalProvider/ModalProvider";

import Button from "react-bootstrap/Button";

import { SeatMapNavigation } from "../../../SeatMapNavigation";
import AssignTicketsModalContentV2 from "../../../../providers/AssignToProvider/AssignTicketsModalContent/AssignTicketsModalContentV2";
import AssignTicketsModalContent from "../../../../providers/AssignToProvider/AssignTicketsModalContent/AssignTicketsModalContent";
export default function Navigation({
  ticketType,
  event,
  isEventPublished,
  hasEventEnded,
  isMapDisabled,
  configuration,
  selectedSeatIds,
  handleShowResetConfiguration,
  isExistingOrder,
  handleGoBack,
  isDisabled,
  data,
}) {
  const { openModal } = useModal();

  useEffect(() => {}, [selectedSeatIds]);

  const openAssignModal = () => {
    openModal(
      AssignTicketsModalContent,
      {
        event,
        eventPackage: undefined,
        selectedSeatIds,
        data,
      },
      { className: "modal-xl", contentClassName: "h-md" },
    );
  };

  const openAssignModalV2 = () => {
    openModal(
      AssignTicketsModalContentV2,
      {
        event,
        eventPackage: undefined,
        selectedSeatIds,
        data,
      },
      { className: "modal-xl", contentClassName: "" },
    );
  };

  const getButton = () => {
    return isExistingOrder ? (
      <Button
        onClick={openAssignModal}
        disabled={
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0
        }
      >
        Adjust order
      </Button>
    ) : (
      <>
        <Button
          onClick={openAssignModalV2}
          disabled={
            isDisabled ||
            isMapDisabled ||
            !selectedSeatIds ||
            Object.keys(selectedSeatIds)?.length === 0
          }
        >
          Assign tickets
        </Button>
      </>
    );
  };

  return (
    <SeatMapNavigation
      event={event}
      configuration={configuration}
      showReset={false}
      isDisabled={isEventPublished || hasEventEnded}
      handleLeave={handleGoBack}
      handleShowReset={handleShowResetConfiguration}
      getButton={getButton}
    >
      {/* <Button
        onClick={openAssignModalV2}
        disabled={
          isDisabled ||
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0
        }
        className={`${process.env.NODE_ENV !== "production" ? "" : "opacity-0"}`}
      >
        Assign tickets V2
      </Button> */}
    </SeatMapNavigation>
  );
}
